import { useUserCurrency } from "@/hooks/useUserCurrency";
import { formatKz } from "@/lib/utils";
import { formatMoney } from "@/lib/money";

/**
 * Retorna uma função `fmt(v)` que formata um valor originalmente em AOA
 * na moeda de exibição do utilizador (perfil verificado / preferência / geo IP).
 */
export function useFmt() {
  const { currency } = useUserCurrency();
  return (v: number) => (currency === "AOA" ? formatKz(v) : formatMoney(v, currency));
}

export default useFmt;
